// @ts-nocheck
import React from 'react';
import { Dialog, DialogSuspense, FormattedMessage as T } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';

import { compose } from '@/utils';

const CarrierFormDialogContent = React.lazy(
  () => import('./CarrierFormDialogContent'),
);

/**
 * Carrier form dialog.
 */
function CarrierFormDialog({
  dialogName,
  payload: { carrierId = null, action } = {},
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      title={action === 'edit' ? <T id={'edit_carrier'} /> : <T id={'new_carrier'} />}
      isOpen={isOpen}
      canEscapeJeyClose={true}
      autoFocus={true}
      className={'dialog--carrier-form'}
      style={{ width: '444px', maxWidth: '95vw' }}
    >
      <DialogSuspense>
        <CarrierFormDialogContent
          dialogName={dialogName}
          carrierId={carrierId}
          action={action}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(CarrierFormDialog);
